import { isValidSessionId } from '@auxcast/protocol';

/**
 * `isValidSessionId` is a type predicate over `unknown`, which narrows a `string`
 * to `never` in the negative branch. Wrapping it keeps the plain boolean.
 */
function looksLikeSessionId(value: string): boolean {
  return isValidSessionId(value);
}

/**
 * Pull a session id out of whatever the user pasted: a full listen URL, a
 * `/s/<id>` path, or the bare code. Returns null when nothing usable is in there.
 */
export function parseSessionInput(input: string): string | null {
  const trimmed = input.trim();
  if (trimmed === '') return null;

  if (looksLikeSessionId(trimmed)) return trimmed;

  const fromPath = /\/s\/([^/?#\s]+)/.exec(trimmed);
  if (fromPath?.[1] && looksLikeSessionId(fromPath[1])) return fromPath[1];

  const lastSegment = trimmed.split(/[/?#]/).filter(Boolean).pop();
  if (lastSegment && looksLikeSessionId(lastSegment)) return lastSegment;

  return null;
}

/** Absolute `ws(s)://` URL for the listener socket on the current origin. */
export function listenSocketUrl(sessionId: string, location: Location = window.location): string {
  const scheme = location.protocol === 'https:' ? 'wss:' : 'ws:';
  return `${scheme}//${location.host}/listen/${encodeURIComponent(sessionId)}`;
}

export function shareableListenUrl(sessionId: string, location: Location = window.location): string {
  return `${location.protocol}//${location.host}/s/${encodeURIComponent(sessionId)}`;
}
